import { FC, useCallback } from "react";
import {
  RoomOutput2,
  useWatchRooms2Subscription,
} from "~@/graphql/codegen/generated";
import useInternalUser from "~@/hooks/useInternalUser";
import useRemoveChatRooms from "~@/pages/chat-room/hooks/useRemoveChatRooms";
import useStoreChatRooms from "~@/pages/chat-room/hooks/useStoreChatRooms";

type WatchRoomsProps = {
  teamId: string;
};

// Компонент для подписки на изменения комнат чата
const WatchRooms: FC<WatchRoomsProps> = ({ teamId }) => {
  const { internalUser } = useInternalUser();

  const removeChatRooms = useRemoveChatRooms();
  const storeChatRooms = useStoreChatRooms();

  // Подписка на изменения комнат чата
  useWatchRooms2Subscription({
    skip: !internalUser, // Пропускаем подписку, если нет внутреннего пользователя
    variables: {
      teamId,
      userId: internalUser?.id as string,
    },
    onData({ data: { data } }) {
      const rooms = data?.watchRooms2?.rooms; // Получаем комнаты из данных подписки

      if (Array.isArray(rooms)) {
        removeChatRooms(rooms as RoomOutput2[]); // Удаляем комнаты
        storeChatRooms(rooms as RoomOutput2[]); // Сохраняем комнаты
      }
    },
  });

  return null; // Компонент не отображает ничего в UI
};

// Хук для создания компонентов подписки на изменения комнат чата для каждой команды пользователя
const useWatchRooms = () => {
  const { internalUser } = useInternalUser();

  // Функция для создания компонентов WatchRooms для каждой команды пользователя
  const watchRooms = useCallback(() => {
    return internalUser?.teams?.map((team) => {
      if (!team) return null; // Пропускаем, если нет команды

      return <WatchRooms key={team.id} teamId={team.id} />; // Создаём компонент WatchRooms для каждой команды
    });
  }, [internalUser]);

  return watchRooms; // Возвращаем функцию для использования в компонентах
};

export default useWatchRooms;
